import React from 'react';
import useGetLegalDocuments from '../../data/winefo-public/use-get-legal-documents';
import LegalDocuments from '../../components/legal-documents/legal-documents';
import { LegalDocumentType } from '../../models/legal-documents';

const PrivacyPolicy: React.FC = () => {
  const { data } = useGetLegalDocuments('PP');

  return (
    <LegalDocuments
      documentLocations={data?.documentLocations}
      type={LegalDocumentType.PRIVACY_POLICY}
    />
  );
};

export default PrivacyPolicy;
